module.exports = __webpack_public_path__ + "blilliant.5f236513.png";